import {useMutation, useQueryClient} from "react-query";
import {useParams} from "react-router-dom";
import Alert from "react-s-alert";
import {
  ManageSsoConfigurationRequest,
  SsoService,
} from "../../../services/SsoService";
import {buildResponseErrorMessage} from "../../../services/api/errorHelpers";

export const useManageSsoConfiguration = () => {
  const queryClient = useQueryClient();
  const {organizationId} = useParams<{organizationId: string}>();

  return useMutation(
    (data: ManageSsoConfigurationRequest) =>
      SsoService.manageConfiguration(organizationId, data),
    {
      onSuccess: () => {
        Alert.success("SSO management settings were successfully updated.");
        queryClient.invalidateQueries(["ssoConfiguration"]);
      },
      onError: async resp => {
        Alert.error(
          await buildResponseErrorMessage(
            resp,
            "Failed to update SSO management settings.",
          ),
        );
      },
    },
  );
};
